import { useQueryClient } from "@tanstack/react-query";

import { describeApiError } from "@/api/errors";
import { Button } from "@/components/Button";
import { Tag } from "@/components/Tag";

export interface ErrorStateProps {
  title: string;
  error: unknown;
  /** 是否提供"重试"按钮（重新拉取当前查询）。 */
  onRetry?: () => void;
  /** 补充的恢复指引，会追加在自动建议之后。 */
  hint?: string;
}

/**
 * 查询失败时的**唯一**呈现方式（CONSTITUTION D1 / RULES §11.2）。
 *
 * 不使用任何兜底数据：错误就是错误。信息按「发生了什么 → 为什么 → 下一步」组织，
 * 并保留 request_id 供回溯（宪法 A8 / B6）。
 */
export function ErrorState({ title, error, onRetry, hint }: ErrorStateProps) {
  const client = useQueryClient();
  const view = describeApiError(error);

  return (
    <div className="empty-state">
      <strong>{title}</strong>
      <p>{view.message}</p>
      {view.action ? <p>{view.action}</p> : null}
      {hint ? <p>{hint}</p> : null}
      <div className="meta-row">
        <Tag tone="red">{view.code}</Tag>
        {view.requestId ? <Tag>请求 {view.requestId.slice(0, 12)}</Tag> : null}
      </div>
      <Button
        variant="quiet"
        onClick={() => {
          onRetry?.();
          void client.invalidateQueries();
        }}
      >
        重试
      </Button>
    </div>
  );
}
